module.exports = __webpack_public_path__ + "static/media/dropdown_sales_image.7f98d8d5.svg";